import {
  FETCH_POWER_METER_REQUEST,
  FETCH_POWER_METER_SUCCESS,
  FETCH_POWER_METER_FAILURE,
} from '../actions/powerMeterActions';

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const powerMeterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_POWER_METER_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_POWER_METER_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_POWER_METER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default powerMeterReducer;